import { scheme, sectionScheme } from "./schemes";

/**
 * Every major page can choose its own color scheme from admin.
 * Config key: `page_scheme_<slug>` in site_content.
 *
 *   / → home
 *   /artists / /artists/:slug → artists
 *   /shop → shop
 *   /after-dark → after-dark
 *   /contact → contact
 *   /studio → studio
 *   /events / /events/:slug → events
 *
 * Each page feels like a different "room" in the same world.
 */
const SLUG_MAP = [
    ["/after-dark", "after-dark"],
    ["/artists", "artists"],
    ["/shop", "shop"],
    ["/contact", "contact"],
    ["/studio", "studio"],
    ["/events", "events"],
    ["/lab", "lab"],
    ["/admin", "admin"],
    ["/member", "member"],
];

// Default per-page — the site's visual identity is intentionally tight, so
// every page shares the `light` scheme unless the admin overrides it in
// site_content (`page_scheme_<slug>`). Pick `mustard` for a warm hero and
// `night` for the "after dark" side of the world.
const DEFAULT_SCHEMES = {
    home: "night",
    artists: "night",
    shop: "night",
    "after-dark": "night",
    contact: "night",
    studio: "night",
    events: "night",
    lab: "night",
    admin: "light",
    member: "light",
};

export function pageSlugFromPath(pathname = "/") {
    if (!pathname || pathname === "/") return "home";
    for (const [prefix, slug] of SLUG_MAP) {
        if (pathname === prefix || pathname.startsWith(prefix + "/")) return slug;
    }
    return "home";
}

export function pageSchemeFor(pathname, content = {}) {
    const slug = pageSlugFromPath(pathname);
    const override = content[`page_scheme_${slug}`];
    const name = (override && override !== "") ? override : (DEFAULT_SCHEMES[slug] || "light");
    // Note: previously called `sectionScheme(name)` here which was wrong —
    // sectionScheme expects (siteContent, sectionKey), so it always fell back
    // to the default. That's why page schemes appeared to do nothing.
    return { slug, scheme: name, ...scheme(name) };
}

export { DEFAULT_SCHEMES, sectionScheme };
